<script lang="ts" setup>
import { addStickyClass } from '~/utils/addStickyClass'
import { Routes } from '~/enums/Routes'
import getLocalizedRoute from '~/utils/getLocalizedRoute'
import LayoutEnum from '~/enums/LayoutEnum'
import { useStoreConfig } from '~/store/storeConfig'

const { type } = defineProps<{ type?: LayoutEnum.Market | LayoutEnum.Quote }>()
const headerRef = ref<HTMLDivElement>()
const placeholderRef = ref<HTMLDivElement>()
const logos = await useAssetManager().getLogos()
const { getSlug } = useHowTo()

const scrollHandler = () => addStickyClass(headerRef.value, placeholderRef.value)
const storeConfig = useStoreConfig()

onMounted(() => {
  addStickyClass(headerRef.value)
  window?.addEventListener('scroll', scrollHandler)
})

onBeforeUnmount(() => {
  window?.removeEventListener('scroll', scrollHandler)
})
</script>

<template>
  <header :key="storeConfig.getIsMobile.valueOf.toString()" :class="{ 'desktop-header': true, [type!]: Boolean(type) }">
    <section class="flex flex-col w-full">
      <div class="flex flex-col items-center justify-center w-full py-4">
        <NuxtLink :to="getLocalizedRoute(Routes.Index)">
          <img :src="logos.logo" class="logo" alt="Logo" />
        </NuxtLink>
      </div>

      <div ref="headerRef" class="w-full lg:px-4">
        <div class="flex max-w-xlg bg-white/20 w-full items-center justify-between m-auto rounded-md">
          <div>
            <NavbarAe :type="type" />
          </div>

          <div class="profile flex items-center h-full justify-end">
            <HeaderHowTo :slug="getSlug()" />
            <HeaderTracking />
            <HeaderAccountAe />
          </div>
        </div>
      </div>
    </section>
    <div ref="placeholderRef" class="header-placeholder" />
  </header>
</template>

<style lang="scss" scoped>
.ae .desktop-header {
  @apply bg-brand-primaryLight pb-4;

  .sticky {
    @apply bg-brand-primaryLight border-b border-white/20;

    position: fixed !important;
    z-index: 33;
    width: 100%;
    left: 0;
    top: 0;
    padding: 0.5rem 0;

    & + .header-placeholder {
      height: 80px;
    }
  }
}
</style>
